export const ELEMENT_FEATURES = {
    DOCUMENT: 'document',
    CLONE: 'clone',
    DESCRIPTION: 'description',
    TRANSPARENT: 'transparent',
    HEADER: 'header-card',
};
